export enum RemittanceStatusIdEnum {
  Pending = 1,
  Submitted = 2,
  InReview = 3,
  Approved = 4,
  Failed = 5,
  NeedsAttention = 6
}
